<template>
  <div :class="$style.reply">
    <div v-if="isPhotoAttachment" :class="$style.imgWrap">
      <img v-if="isPhotoAttachment" :src="message.attachment.link" alt="attached image" :class="$style.image" />
    </div>
    <div :class="$style.replyBody">
      <div :class="$style.replyName">{{ title }}</div>
      <div :class="$style.replyText" v-html="replyText"></div>
    </div>
    <slot />
  </div>
</template>

<script>
import { ATTACHMENT_CODE } from '@/models/Message'
import { eventTypes, msgTypes } from '@/helpers/variables'

export default {
  name: 'message-reply-matrix',
  props: {
    message: Object,
    room: Object,
    isEdit: Boolean
  },
  computed: {
    replyUser () {
      if (this.isEdit) return
      return this.$store.getters['entities/users/find'](this.message.senderId)
    },
    title () {
      if (this.isEdit) return this.$t('chat.editMessage')
      return this.replyUser ? this.replyUser.displayName : ''
    },
    replyText () {
      if (!this.message.content) return ''
      return (
        this.message.content.new_body ||
        this.message.content.body ||
        this.message.content['m.relates_to']['m.in_reply_to'].event_id
      )
    },
    isPhotoAttachment () {
      if (!this.message.attachment) return false
      return this.message.attachment.type === ATTACHMENT_CODE.image
    }
  },
  watch: {
    message: {
      deep: true,
      immediate: true,
      handler () {
        this.getCurrentMessage()
      }
    }
  },
  methods: {
    async getGif (giphyId) {
      if (!giphyId || this.giphy) return
      await this.$store.dispatch('giphy/getById', giphyId)
    },
    async getCurrentMessage () {
      await window.matrixSDK
        .relations(this.message.room_id, this.message.event_id, msgTypes.replace, eventTypes.message)
        // eslint-disable-next-line no-console
        .catch(error => console.error(error))
    }
  }
}
</script>

<style module lang="scss">
.reply {
  border-left: 2px solid $text-colored;
  padding-left: 8px;
  margin-bottom: 6px;
  display: flex;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  &Body {
    flex-grow: 1;
    min-width: 0;
  }
  &Name {
    font-weight: 500;
    color: $text-colored;
    margin-bottom: 4px;
  }
  &Name,
  &Text {
    white-space: nowrap; // pre-wrap;
    text-overflow: ellipsis;
    overflow: hidden;
    user-select: none;
    a {
      pointer-events: none;
    }
  }
}
.imgWrap {
  width: 44px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image {
  max-width: 44px;
  max-height: 36px;
}
</style>
